module.exports = __webpack_public_path__ + "img/icon-phone.b3e926a9.svg";